export const CREATE_CONTRACT_MUTATION = `
  mutation CreateContract($object: contracts_insert_input!) {
    insert_contracts_one(object: $object) {
      id
      contract_subject_id
      scope_of_work_id
      pricing_method_id
      work_status_id
      contract_signing_date
      invoice_issue_date
      auto_renewal
      renewal_period
      first_price_increase_period
      inflation_clause
      work_start_date
      work_started_without_contract
      protocol_start_date
      protocol_end_date
      comment
      contract_description
      contract_pdf_key
      protocol_pdf_key
      contract_pdf_size
      protocol_pdf_size
      company_id
      firm_id
      firm_short_name
      created_at
      updated_at
      contract_subject {
        id
        name
      }
      scope_of_work {
        id
        name
      }
      pricing_method {
        id
        name
      }
      work_status {
        id
        name
      }
      company {
        id
        name
      }
      firm {
        id
        firm_name
        firm_short_name
      }
    }
  }
`;

export const UPDATE_CONTRACT_MUTATION = `
  mutation UpdateContract($id: Int!, $set: contracts_set_input!) {
    update_contracts_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      contract_subject_id
      scope_of_work_id
      pricing_method_id
      work_status_id
      contract_signing_date
      invoice_issue_date
      auto_renewal
      renewal_period
      first_price_increase_period
      inflation_clause
      work_start_date
      work_started_without_contract
      protocol_start_date
      protocol_end_date
      comment
      contract_description
      contract_pdf_key
      protocol_pdf_key
      contract_pdf_size
      protocol_pdf_size
      company_id
      firm_id
      firm_short_name
      created_at
      updated_at
      contract_subject {
        id
        name
      }
      scope_of_work {
        id
        name
      }
      pricing_method {
        id
        name
      }
      work_status {
        id
        name
      }
      company {
        id
        name
      }
      firm {
        id
        firm_name
        firm_short_name
      }
    }
  }
`;

export const DELETE_CONTRACT_MUTATION = `
  mutation DeleteContract($id: Int!) {
    delete_contracts_by_pk(id: $id) {
      id
    }
  }
`; 